var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.1 27.5",
    style: {
      enableBackground: "new 0 0 29.1 27.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,23.8L20.5,2.6c-0.1-0.4-0.4-0.7-0.7-0.9c-0.3-0.2-0.7-0.3-1.1-0.3h-8.4c-0.4,0-0.7,0.1-1,0.3 C9.1,1.9,8.8,2.2,8.7,2.6L1.5,23.8c-0.1,0.3-0.1,0.6-0.1,0.9c0.1,0.3,0.2,0.5,0.3,0.8c0.2,0.2,0.4,0.4,0.7,0.5 C2.7,26,3,26.1,3.3,26h5.1c0.8,0,1.4-0.5,1.7-1.2l1.1-3.1l5.3,4c0.3,0.2,0.7,0.3,1.1,0.3h8.3c0.3,0,0.6,0,0.8-0.2 c0.3-0.1,0.5-0.3,0.6-0.5c0.2-0.2,0.3-0.5,0.3-0.8C27.7,24.3,27.7,24,27.6,23.8z M17.6,24.9c-0.1,0-0.3,0-0.4-0.1l-10-7.4 l-0.2-0.1h5.3l0.1-0.4l1.8-4.5l4,11.7c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.2,0.2 C17.9,24.9,17.8,24.9,17.6,24.9L17.6,24.9z M25.9,24.9h-6.6c0.1-0.4,0.1-0.8,0-1.2L12.2,2.6h6.6c0.1,0,0.2,0,0.4,0.1 c0.1,0.1,0.2,0.2,0.2,0.3l7.1,21.2c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.1,0.1-0.2,0.2C26.1,24.9,26,24.9,25.9,24.9L25.9,24.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.91ce04c62813587e58066d53eee87e4d.svg";
export { ForwardRef as ReactComponent };